module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"createProjectNum":"创建@:common.project数","packageAccountsTotalNum":"套餐内账号总数","projectsTotalNum":"@:common.project总数","projectsTotalPV":"@:common.project浏览次数","packageAccountsUsedNum":"当前账号总数","recentCreateProjectList":"最近创建@:common.project","projectName":"@:common.project名称","projectNum":"@:common.project数：","projectCreator":"创建人","projectCreatedDate":"创建日期","projectPV":"浏览人次","seeAndShare":"查看及分享","periods":{"past":"过去","week":"一周","month":"一个月","season":"三个月","year":"一年"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/dashboard/index.vue
// module id = 333
// module chunks = 3